module.exports = __webpack_public_path__ + "static/media/Template_61.9366eebb.png";